export default __webpack_public_path__ + "static/business-availability-fd708d9478997e901c45df30f56262b0.webp";